const datetimeFormatter = timestamp => (new Date(timestamp*1000)).toLocaleString()
export default datetimeFormatter
